<template>
  <div id="dashboard">
    <div id="leftmenu">
      <div>
        <div id="userMainDEC">
          <b-modal
            centered
            id="changePassword"
            ref="pChnage"
            title="Change Password"
            @hidden="resetModal"
            @ok="changePassoword"
          >
            <div>
              <v-text-field
                v-model="email"
                :rules="rules.email"
                color="blue darken-2"
                label="Enter Email Address"
              ></v-text-field>
              <v-text-field
                v-if="!this.$store.state.userData.isSocial"
                v-model="currentPassword"
                color="blue darken-2"
                label="Enter Old Password"
              ></v-text-field>
              <v-text-field
                v-model="newPassword"
                :rules="rules.passwordRules"
                color="blue darken-2"
                label="Enter New Password"
              ></v-text-field>
            </div>
          </b-modal>
          <div id="userDec">
            <div id="profile-img">
              <img
                style="width: 64px;border-radius: 50%;height: 64px;"
                v-if="
                  this.$store.getters.isAuthenticated &&
                    this.$store.state.userData &&
                    this.$store.state.userData.userProfilePic
                "
                :src="this.$store.state.userData.userProfilePic"
              />
              <img
                v-else
                src="../assets/svg/profiledark.svg"
                class="profileicon"
              />
            </div>
            <div id="user-name-parent">
              <span>
                <p class="head-profile">Hello,</p>
                <p class="head-name" v-if="this.$store.state.userData.orgname">
                  {{ this.$store.state.userData.orgname }}
                </p>
                <p class="head-name" v-if="!this.$store.state.userData.orgname">
                  User
                </p>
              </span>
              <span style="color:#4415e5">
                <a
                  @click="
                    () => {
                      this.$refs.inputFile.click();
                    }
                  "
                  >Change Profile Image</a
                >
              </span>
              <input
                style="visibility: hidden;position: absolute;"
                ref="inputFile"
                type="file"
                id="myFile"
                @change="uploadPic"
              />
            </div>
          </div>
        </div>
        <div id="userDesMenu">
          <div class="mainDiv">
            <div @click="showProfile" class="active userOpt">
              <v-icon>person</v-icon>
              <div class="mainSel">ACCOUNT SETTINGS</div>
            </div>
            <div>
              <a @click="changeSelected('pInfo')">
                <div id="pInfo2" class="subSel active2">
                  Profile Information
                </div>
              </a>

              <a
                v-if="this.$store.state.userData.usertype !== 'individual'"
                @click="changeSelected('cInfo')"
              >
                <div id="cInfo2" class="subSel">Company Information</div>
              </a>
              <a
                v-if="this.$store.state.userData.usertype == 'individual'"
                @click="changeSelected('cInfo')"
              >
                <div id="cInfo2" class="subSel">User Information</div>
              </a>
            </div>
          </div>
          <div @click="showOrder" class="mainDiv">
            <div class="userOpt">
              <v-icon>reorder</v-icon>
              <a class="mainSel">Order</a>
            </div>
          </div>
          <div @click="showWish" class="mainDiv">
            <div class="userOpt">
              <v-icon>favorite_border</v-icon>
              <a class="mainSel">My Wish List</a>
            </div>
          </div>
          <div @click="showNotification" class="mainDiv">
            <div class="userOpt">
              <v-icon>notifications_none</v-icon>
              <a class="mainSel">Notifications</a>
              <v-badge>
                <template v-slot:badge>
                  <span>{{ notificationcount }}</span>
                </template>
              </v-badge>
            </div>
          </div>
          <div @click="showHelp" class="mainDiv">
            <div class="userOpt">
              <v-icon>help_outline</v-icon>
              <a class="mainSel">Help Center</a>
            </div>
          </div>
          <div @click="logOut" class="mainDiv">
            <div class="userOpt">
              <v-icon>power_settings_new</v-icon>
              <a class="mainSel">Logout</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="rightmenu">
      <b-modal
        centered
        id="modal-prevent-closing4"
        ref="eInfo"
        title="Submit Your Edits"
        @ok="handleEinfo"
      >
        <div>
          <v-text-field
            v-model="email"
            :rules="rules.email"
            color="blue darken-2"
            label="Enter New Email Address"
            required
          ></v-text-field>
          <v-text-field
            v-if="!this.$store.state.userData.isSocial"
            v-model="currentPassword"
            type="password"
            color="blue darken-2"
            label="Enter Old Password"
            required
          ></v-text-field>
          <v-text-field
            v-model="newPassword"
            type="password"
            :rules="rules.passwordRules"
            color="blue darken-2"
            label="Enter New Password"
            required
          ></v-text-field>
        </div>
      </b-modal>
      <div
        v-if="this.$store.state.selectedInfo == 'pInfo'"
        id="pInfo "
        class="infoRow"
      >
        <div class="infoI">
          <a v-b-modal.changePassword style="color:blue"
            >Change Password &nbsp;</a
          >
          <v-icon
            @click="editNow('pInfo')"
            v-if="this.$store.state.profileEditingOn == false"
            >edit</v-icon
          >
          <v-icon
            v-if="this.$store.state.profileEditingOn == true"
            color="primary"
            >edit</v-icon
          >
        </div>
        <div class="editingD">
          <div
            v-if="this.$store.state.userData.usertype !== 'individual'"
            class="profileRightSide"
          >
            <p>Organisation</p>
          </div>
          <div
            v-if="this.$store.state.userData.usertype == 'individual'"
            class="profileRightSide"
          >
            <p>Name</p>
          </div>

          <div class="sideEditBox">
            <v-text-field
              :disabled="editingOn == false"
              v-model="orgname"
              :rules="rules.orgname"
              label="Name"
              single-line
              outline
            ></v-text-field>
          </div>
        </div>
        <div class="editingD">
          <div class="profileRightSide">
            <p>Email Address</p>
          </div>

          <div class="sideEditBox">
            <v-text-field
              v-b-modal.modal-prevent-closing4
              :rules="rules.email"
              v-model="email"
              label="Email Address"
              single-line
              outline
            ></v-text-field>
          </div>
        </div>
        <div class="editingD">
          <div class="profileRightSide">
            <p>Phone</p>
          </div>

          <div class="sideEditBox">
            <v-text-field
              :disabled="editingOn == false"
              :rules="rules.phone"
              v-model="phone"
              label="Phone"
              single-line
              outline
            ></v-text-field>
          </div>
        </div>
        <div class="editingD">
          <div class="profileRightSide">
            <p>Build/Flat No</p>
          </div>

          <div class="sideEditBox">
            <v-text-field
              :disabled="editingOn == false"
              v-model="flat_building"
              :rules="rules.flat_building"
              label="Building/Flat No"
              single-line
              outline
            ></v-text-field>
          </div>
        </div>
        <div class="editingD">
          <div class="profileRightSide">
            <p>Landmark</p>
          </div>

          <div class="sideEditBox">
            <v-text-field
              :disabled="editingOn == false"
              v-model="landmark"
              :rules="rules.landmark"
              label="Landmark"
              single-line
              outline
            ></v-text-field>
          </div>
        </div>
        <div class="editingD">
          <div class="profileRightSide">
            <p>City</p>
          </div>

          <div class="sideEditBox">
            <v-text-field
              :disabled="editingOn == false"
              v-model="city"
              :rules="rules.city"
              label="City"
              single-line
              outline
            ></v-text-field>
          </div>
        </div>
        <div class="editingD">
          <div class="profileRightSide">
            <p>State</p>
          </div>

          <div class="sideEditBox">
            <v-text-field
              :disabled="editingOn == false"
              v-model="state"
              :rules="rules.state"
              label="State"
              single-line
              outline
            ></v-text-field>
          </div>
        </div>
        <div class="editingD">
          <div class="profileRightSide">
            <p>Country</p>
          </div>

          <div class="sideEditBox">
            <v-text-field
              :disabled="editingOn == false"
              v-model="country"
              :rules="rules.state"
              label="Country"
              single-line
              outline
            ></v-text-field>
          </div>
        </div>
      </div>
      <div v-if="this.$store.state.selectedInfo == 'cInfo'" id="cInfo" class>
        <div class="infoI">
          <a v-b-modal.changePassword style="color:blue"
            >Change Password &nbsp;</a
          >

          <v-icon
            @click="editNow('aInfo')"
            v-if="this.$store.state.profileEditingOn == false"
            >edit</v-icon
          >
          <v-icon
            v-if="this.$store.state.profileEditingOn == true"
            color="primary"
            >edit</v-icon
          >
        </div>
        <div class="editingD">
          <div
            v-if="this.$store.state.userData.usertype !== 'individual'"
            class="profileRightSide"
          >
            <p>Organisation Name</p>
          </div>
          <div
            v-if="this.$store.state.userData.usertype == 'individual'"
            class="profileRightSide"
          >
            <p>Name</p>
          </div>

          <div class="sideEditBox">
            <v-text-field
              :disabled="editingOn == false"
              v-model="orgname"
              :rules="rules.orgname"
              label="Organisation Name"
              single-line
              outline
            ></v-text-field>
          </div>
        </div>
        <!-- <div v-if="this.$store.state.userData.usertype == 'organization'" class="editingD">
          <div class="profileRightSide">
            <p>Company Identification Number</p>
          </div>

          <div class="sideEditBox">
            <v-text-field
              :disabled="editingOn == false"
              v-model="cin"
              :rules="rules.cin"
              label="Company Identification Number"
              single-line
              outline
            ></v-text-field>
          </div>
        </div>-->
        <div
          v-if="this.$store.state.userData.usertype == 'organization'"
          class="editingD"
        >
          <div class="profileRightSide">
            <p>GSTIN</p>
          </div>

          <div class="sideEditBox">
            <v-text-field
              :disabled="editingOn == false"
              v-model="gst"
              :rules="rules.gst"
              label="GSTIN"
              single-line
              outline
            ></v-text-field>
          </div>
        </div>
        <div
          v-if="this.$store.state.userData.usertype == 'individual'"
          class="editingD"
        >
          <div class="profileRightSide">
            <p>GSTIN (Optional)</p>
          </div>

          <div class="sideEditBox">
            <v-text-field
              :disabled="editingOn == false"
              v-model="gst"
              :rules="rules.gst"
              label="GSTIN"
              single-line
              outline
            ></v-text-field>
          </div>
        </div>
        <div style="width: 100%;">
          <div class="profileRightSide">
            <p>Billing Address</p>
          </div>

          <div class="sideEditBox">
            <v-textarea
              :disabled="editingOn == false"
              outline
              label="Billing Address"
              v-model="billingadd"
            ></v-textarea>
          </div>
        </div>
      </div>
      <div v-if="this.$store.state.profileEditingOn == true" id="submitBtn">
        <v-btn @click="saveNow" color="warning">Submit</v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import * as firebase from "firebase";
import { db } from "../main";
export default {
  name: "profile",
  components: {},
  data() {
    return {
      orgname: null,
      email: this.$store.state.user.user.email,
      phone: null,
      flat_building: null,
      landmark: null,
      currentPassword: null,
      city: null,
      state: null,
      country: null,
      accountholdername: null,
      bankname: null,
      accountno: null,
      ifsc: null,
      cin: null,
      gst: null,
      pan: null,
      userData: [],
      newPassword: null,
      billingadd: null,
      rules: {
        Name: [
          val => (val || "").length > 0 || "This field is required",
          v => /^[a-zA-Z\s]+$/.test(v) || "Please enter correct details"
        ],
        email: [v => /.+@.+/.test(v) || "E-mail must be valid"],
        flat_building: [
          val => (val || "").length > 0 || "This field is required",
          v => /^[-,/.&+\w\s]*$/.test(v) || "Please enter correct details "
        ],
        state: [
          val => (val || "").length > 0 || "This field is required",
          v => /^[-,/.&+\w\s]+$/.test(v) || "Please enter correct name"
        ],
        city: [
          val => (val || "").length > 0 || "This field is required",
          v => /^[a-zA-Z\s]+$/.test(v) || "Please enter correct name"
        ],
        landmark: [
          val => (val || "").length > 0 || "This field is required",
          v => /^[-,/.&+\w\s]*$/.test(v) || "Please enter correct details "
        ],
        pincode: [
          val => (val || "").length == 6 || "This field is required",
          v => /^[0-9]+$/.test(v) || "Please enter correct details"
        ],
        locality: [
          val => (val || "").length > 0 || "This field is required",
          v => /^[-,/.&+\w\s]*$/.test(v) || "Please enter correct details",
          v => !/^[0-9]+$/.test(v) || "Please enter correct details"
        ],
        address: [
          v => /^[-,/.&+\w\s]*$/.test(v) || "Please enter correct details",
          v => !/^[0-9]+$/.test(v) || "Please enter correct details"
        ],
        orgname: [
          val => (val || "").length > 0 || "This field is required",
          v => /^[a-zA-Z\s]+$/.test(v) || "Please enter correct name"
        ],
        companyType: [v => !!v || "This field is required"],
        cin: [
          val => (val || "").length == 21 || "Please enter a valid value",
          v =>
            /^([L|U]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$/.test(
              v
            ) || "Please enter valid number"
        ],
        gst: [
          val => (val || "").length == 15 || "Complete Your GSTIN Number",
          v =>
            /^([0][1-9]|[1-2][0-9]|[3][0-5])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z\s]{1})+$/.test(
              v
            ) || "Please enter valid number"
        ],
        gst2: [
          v =>
            /^([0][1-9]|[1-2][0-9]|[3][0-5])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z\s]{1})+$/.test(
              v
            ) || "Please enter valid number"
        ],
        ifsc: [
          val => (val || "").length > 0 || "Ifsc is required",
          v => /^[A-Za-z]{4}\d{7}$/.test(v) || "Please enter valid IFSC code"
        ],
        accountHolderName: [
          val => (val || "").length > 0 || "This field is required",
          v => /^[a-zA-Z\s]+$/.test(v) || "Please enter correct name"
        ],
        accountNo: [
          val => /^[0-9]+$/.test(val) || "Please enter a valid account number",
          val => (val || "").length > 0 || "This field is required"
        ],
        bankName: [
          val => (val || "").length > 0 || "This field is required",
          v => /^[a-zA-Z\s]+$/.test(v) || "Please enter correct name"
        ],
        upi: [v => /.+@.+/.test(v) || "UPI must be valid"],
        pan: [
          v => !!v || "This field is required",
          v =>
            /^[A-Za-z]{5}\d{4}[A-Za-z]{1}$/.test(v) ||
            "Please enter valid number"
        ],
        phone: [
          val => /^[0-9]+$/.test(val) || "Please enter a valid phone number",
          val =>
            (val || "").length == 10 || "Phone number should be of length 10"
        ],
        passwordRules: [
          v => !!v || "Password is required",
          v =>
            (/.{8,}/.test(v) &&
              /[0-9]+/.test(v) &&
              /[A-Z]+/.test(v) &&
              /[a-z]+/.test(v)) ||
            "<ul><b>Password requirements</b><li>Atleast one upper case letter</li><li>Atleast one special character</li><li>Minimum 8 digits</li></ul>"
        ]
      }
    };
  },
  created() {
    this.oncreateM();
    this.updateUserData();
  },
  computed: {
    editingOn() {
      return this.$store.state.profileEditingOn;
    },
    notificationcount() {
      let notifications = 0;
      this.$store.state.allproducts.forEach(e => {
        if (e.readuser == 0 && e.uid == this.$store.state.uid) {
          notifications = notifications + 1;
        }
      });
      return notifications;
    }
  },
  destroyed() {
    this.$store.state.selectedInfo = "pInfo";
  },
  methods: {
    uploadPic() {
      var file = document.getElementById("myFile").files[0];
      var storageRef = firebase.storage().ref();
      var thisRef = storageRef.child(
        file.name + this.$store.state.userData.uid + new Date()
      );
      if (file.size < 1024 * 1024) {
        thisRef.put(file).then(snapshot => {
          thisRef.getDownloadURL().then(url => {
            var promise = db
              .collection("orgdetails")
              .doc(this.$store.state.docId)
              .set(
                {
                  userProfilePic: url
                },
                { merge: true }
              )
              .then(() => {
                this.$bvToast.toast("Profile Upload Successfully", {
                  title: "Yheaaa !",
                  variant: "success",
                  solid: true,
                  toaster: "b-toaster-top-center",
                  appendToast: false
                });
              })
              .catch(() => {
                this.$bvToast.toast("Error in upload", {
                  title: "ohhh !",
                  variant: "warning",
                  solid: true,
                  toaster: "b-toaster-top-center",
                  appendToast: false
                });
              });
          });
        });
      } else {
        this.$bvToast.toast("Profile picture must less than 1 Mb", {
          title: "ohhh !",
          variant: "warning",
          solid: true,
          toaster: "b-toaster-top-center",
          appendToast: false
        });
      }
    },
    resetModal() {
      this.currentPassword = null;
      this.newPassword = null;
    },
    changePassoword() {
      if (
        this.$store.state.userData.isSocial &&
        this.$store.state.userData.isSocial == true
      ) {
        const credential = firebase.auth.EmailAuthProvider.credential(
          this.email,
          this.newPassword
        );
        firebase
          .auth()
          .currentUser.linkAndRetrieveDataWithCredential(credential)
          .then(
            usercred => {
              var user = usercred.user;
              db.collection("orgdetails")
                .doc(this.$store.state.docId)
                .update({
                  isSocial: firebase.firestore.FieldValue.delete(),
                  email: this.email
                });
              this.$router.push("/");
            },
            error => {
              this.$bvToast.toast(error.message, {
                title: "Ohh!",
                variant: "warning",
                solid: true,
                toaster: "b-toaster-top-center",
                appendToast: false
              });
            }
          );
      } else {
        var user = firebase.auth().currentUser;
        const credential = firebase.auth.EmailAuthProvider.credential(
          this.$store.state.user.user.email,
          this.currentPassword
        );
        user
          .updatePassword(this.newPassword)
          .then(() => {
            this.$store.dispatch("userSignOut");
            // Update successful.
          })
          .catch(error => {
            this.$bvToast.toast(error.message, {
              title: "Ohh!",
              variant: "warning",
              solid: true,
              toaster: "b-toaster-top-center",
              appendToast: false
            });
            // An error happened.
          });

        // user
        //   .reauthenticateWithCredential(credential)
        //   .then(() => {
        //     this.$bvToast.toast("Passowrd Change Successful", {
        //       title: "Logging Out !",
        //       variant: "success",
        //       solid: true,
        //       toaster: "b-toaster-top-center",
        //       appendToast: false
        //     });
        //     user
        //       .updatePassword(this.newPassword)
        //       .then(() => {
        //         this.$store.dispatch("userSignOut");
        //         console.log("Update passowrd success");
        //         // Update successful.
        //       })
        //       .catch(error => {
        //         console.log("h");

        //         this.$bvToast.toast(error.message, {
        //           title: "Ohh!",
        //           variant: "warning",
        //           solid: true,
        //           toaster: "b-toaster-top-center",
        //           appendToast: false
        //         });
        //         // An error happened.
        //       });
        //   })
        //   .catch(error => {
        //     console.log(error.message);

        //     this.$bvToast.toast(error.message, {
        //       title: "Ohh!",
        //       variant: "warning",
        //       solid: true,
        //       toaster: "b-toaster-top-center",
        //       appendToast: false
        //     });
        //     // An error happened.
        //   });
      }
    },
    handleEinfo(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleEsubmit();
    },
    handleEsubmit() {
      if (
        this.$store.state.userData.isSocial &&
        this.$store.state.userData.isSocial == true
      ) {
        const credential = firebase.auth.EmailAuthProvider.credential(
          this.email,
          this.newPassword
        );
        firebase
          .auth()
          .currentUser.linkAndRetrieveDataWithCredential(credential)
          .then(
            usercred => {
              var user = usercred.user;
              db.collection("orgdetails")
                .doc(this.$store.state.docId)
                .update({
                  isSocial: firebase.firestore.FieldValue.delete(),
                  email: this.email
                });
              this.$router.push("/");
            },
            error => {
              this.$bvToast.toast(error.message, {
                title: "Ohh!",
                variant: "warning",
                solid: true,
                toaster: "b-toaster-top-center",
                appendToast: false
              });
            }
          );

        // var prevUser = auth.currentUser;
        // auth
        //   .signInWithCredential(credential)
        //   .then(function(user) {
        //     console.log("Sign In Success", user);
        //     var currentUser = user;
        //     return user
        //       .delete()
        //       .then(function() {
        //         return prevUser.linkWithCredential(credential);
        //       })
        //       .then(function() {
        //         return auth.signInWithCredential(credential);
        //       });
        //   })
        //   .catch(function(error) {
        //     console.log("Sign In Error", error);
        //   });
      } else {
        firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.currentPassword)
          .then(userCredential => {
            userCredential.user.updateEmail(this.email);
            this.sendData("4");
            this.$nextTick(() => {
              this.$refs.eInfo.hide();
            });
          })
          .catch(error => {
            this.$bvToast.toast(
              "Error in updating Email, you may have entered a wrong password or you are using a social account",
              {
                title: "ohhh !",
                variant: "warning",
                solid: true,
                toaster: "b-toaster-top-center",
                appendToast: false
              }
            );
          });
      }
    },
    oncreateM() {
      if (this.$store.state.userData.orgname)
        this.orgname = this.$store.state.userData.orgname;
      else this.orgname = "";
      if (this.$store.state.userData.phone)
        this.phone = this.$store.state.userData.phone;
      else this.phone = "";
      if (this.$store.state.userData.email)
        this.email = this.$store.state.userData.email;
      else this.email = "";
      if (this.$store.state.userData.flat_building)
        this.flat_building = this.$store.state.userData.flat_building;
      else this.flat_building = "";
      if (this.$store.state.userData.city)
        this.city = this.$store.state.userData.city;
      else this.city = "";
      if (this.$store.state.userData.state)
        this.state = this.$store.state.userData.state;
      else this.state = "";
      if (this.$store.state.userData.country)
        this.country = this.$store.state.userData.country;
      else this.country = "";
      if (this.$store.state.userData.landmark)
        this.landmark = this.$store.state.userData.landmark;
      else this.landmark = "";
      if (this.$store.state.userData.gst)
        this.gst = this.$store.state.userData.gst.toUpperCase();
      else this.gst = "";
      if (this.$store.state.userData.billingadd)
        this.billingadd = this.$store.state.userData.billingadd;
      else this.billingadd = "";
    },
    saveNow() {
      if (this.$store.state.selectedInfo == "pInfo") {
        if (
          this.orgname &&
          this.phone &&
          this.state &&
          this.city &&
          this.country &&
          this.flat_building &&
          this.landmark
        ) {
          var promise = db
            .collection("orgdetails")
            .doc(this.$store.state.docId)
            .set(
              {
                orgname: this.orgname,
                phone: this.phone,
                state: this.state,
                city: this.city,
                country: this.country,
                flat_building: this.flat_building,
                landmark: this.landmark
              },
              { merge: true }
            )
            .then(() => {
              this.$bvToast.toast("Information Updated", {
                title: "Yheaa !",
                variant: "success",
                solid: true,
                toaster: "b-toaster-top-center",
                appendToast: false
              });
              this.updateUserData();

              this.$store.state.profileEditingOn = false;
            });
        } else {
          this.$bvToast.toast(
            "Please Fill all the field to update the details",
            {
              title: "Oops !",
              variant: "warning",
              solid: true,
              toaster: "b-toaster-top-center",
              appendToast: false
            }
          );
        }
      } else {
        if (this.$store.state.userData.usertype == "organization") {
          if (this.orgname && this.gst && this.billingadd) {
            var promise = db
              .collection("orgdetails")
              .doc(this.$store.state.docId)
              .set(
                {
                  orgname: this.orgname,
                  gst: this.gst.toUpperCase(),
                  billingadd: this.billingadd
                },
                { merge: true }
              )
              .then(() => {
                this.$bvToast.toast("Information Updated", {
                  title: "Yheaa !",
                  variant: "success",
                  solid: true,
                  toaster: "b-toaster-top-center",
                  appendToast: false
                });
                this.updateUserData();
                this.$store.state.profileEditingOn = false;
              });
          } else {
            this.$bvToast.toast(
              "Please Fill all the field to update the details",
              {
                title: "Oops !",
                variant: "warning",
                solid: true,
                toaster: "b-toaster-top-center",
                appendToast: false
              }
            );
          }
        } else {
          if (this.orgname && this.billingadd) {
            if (this.gst !== "") {
              var promise = db
                .collection("orgdetails")
                .doc(this.$store.state.docId)
                .set(
                  {
                    orgname: this.orgname,
                    gst: this.gst.toUpperCase(),
                    billingadd: this.billingadd
                  },
                  { merge: true }
                )
                .then(() => {
                  this.$bvToast.toast("Information Updated", {
                    title: "Yheaa !",
                    variant: "success",
                    solid: true,
                    toaster: "b-toaster-top-center",
                    appendToast: false
                  });
                  this.updateUserData();
                  this.$store.state.profileEditingOn = false;
                });
            } else {
              var promise = db
                .collection("orgdetails")
                .doc(this.$store.state.docId)
                .set(
                  {
                    orgname: this.orgname,
                    billingadd: this.billingadd
                  },
                  { merge: true }
                )
                .then(() => {
                  this.$bvToast.toast("Information Updated", {
                    title: "Yheaa !",
                    variant: "success",
                    solid: true,
                    toaster: "b-toaster-top-center",
                    appendToast: false
                  });
                  this.updateUserData();
                  this.$store.state.profileEditingOn = false;
                });
            }
          } else {
            this.$bvToast.toast(
              "Please Fill all the field to update the details",
              {
                title: "Oops !",
                variant: "warning",
                solid: true,
                toaster: "b-toaster-top-center",
                appendToast: false
              }
            );
          }
        }
      }
    },
    updateUserData() {
      if (this.$store.getters.isAuthenticated == true) {
        setTimeout(() => {
          this.userData = [];
          db.collection("orgdetails")
            .where("uid", "==", this.$store.state.uid)
            .onSnapshot(res => {
              const changes = res.docChanges();

              changes.forEach(change => {
                if (change.type === "added") {
                  this.userData.push({
                    ...change.doc.data(),
                    id: change.doc.id
                  });
                  this.$store.state.docId = change.doc.id;
                }
              });
              this.$store.dispatch("updateUserData", {
                currentUserData: this.userData[0]
              });
            });
        }, 10);
      }
    },
    editNow(i) {
      this.$store.state.profileEditingOn = true;
    },
    changeSelected(i) {
      this.oncreateM();
      document
        .getElementById(this.$store.state.selectedInfo + "2")
        .classList.remove("active2");

      this.$store.state.selectedInfo = i;
      this.$store.state.profileEditingOn = false;
      document.getElementById(i + "2").classList.add("active2");
    },
    showProfile() {
      this.$router.push("/profile");
    },
    showOrder() {
      this.$router.push("/orders");
    },
    showWish() {
      this.$router.push("/wishlist");
    },
    showNotification() {
      this.$router.push("/notification");
    },
    showHelp() {
      this.$router.push("/help");
    },
    logOut() {
      this.$store.state.user = null;
      this.$store.state.usertype = null;
      this.$store.state.uid = null;
      this.$store.state.isAuthenticated = false;
      this.$store.state.selproduct = [];
      // this.$store.state.selcategory = null;
      this.$store.state.categories = [];
      this.$store.state.products = [];
      this.$store.state.userData = [];
      this.$store.state.cartData = [];
      this.$store.state.checkout = [];
      this.$store.state.docId = null;
      this.$store.state.totalcartprice = null;
      this.$store.state.localCart = [];
      this.$store.state.localCartCount = [];
      this.$store.state.filterProduct = null;
      this.$store.state.selectedCat = null;
      this.$store.dispatch("userSignOut");
    }
  }
};
</script>
<style scoped>
@media only screen and (min-width: 700px) {
  #profile-img {
    display: flex;
    align-items: center;
  }
  #user-name-parent {
    display: flex;
    flex-flow: column;
    width: 100%;
  }
  #user-name-parent span {
    display: flex;
    flex-direction: row;
  }
  #user-name-parent a {
    margin-left: 10px;
  }
  #submitBtn {
    text-align: center;
  }
  #pInfo {
  }

  .infoI {
    cursor: pointer;
    position: absolute;

    right: 0;
    top: -3rem;
  }
  #aInfo {
  }
  #cInfo {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    position: relative;
    margin-top: 3rem;
  }
  .editingD {
    width: 50%;
  }
  .infoRow {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    position: relative;
    margin: 3rem auto;
  }
  .active {
    background: #f3ededd1;
  }

  .active2 {
    background: #f4f8c0d1;
  }

  .userNameHello {
    padding: 5px 0 0 16px;
  }
  .row {
    display: flex;
    flex-flow: row;
  }

  .sideEditBox {
    margin: 0 10px 0 10px;
  }

  .sideEditBox div {
    margin-top: 5px;
  }
  .subSel {
    font-size: 14px;
    padding: 12px 5px 12px 66px;
    cursor: pointer;
    font-weight: 500;
  }

  .subSel:hover {
    background-color: #f4f8c0d1;
  }
  .mainSel {
    padding: 0 0 12px 20px;
    font-size: 16px;
    font-weight: 500;
    color: #878787;
  }
  .mainDiv {
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
  }
  .userOpt {
    padding: 20px 12px 5px 24px;
    display: flex;
  }
  .row {
    flex-flow: row wrap;
    text-align: center;
  }
  #dashboard {
    display: flex;
    flex-flow: row wrap;
    margin: 0 auto;
    position: relative;
    justify-content: center;
    width: 90%;
    margin-top: 85px;
    margin-bottom: 20px;
  }
  #leftmenu {
    width: 25%;
  }
  #rightmenu {
    width: 65%;
    display: flex;
    flex-flow: column;
    background: white;
    /* border-radius: 10px; */
    margin-left: 15px;
    padding: 10px;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16), 0 2px 2px rgba(0, 0, 0, 0.23);
  }

  .profileRightSide {
    display: flex;
    flex-flow: row;
    margin: 0 10px 0 10px;
  }
  .profileRightSide i {
    margin-left: 10px;
  }

  #profileRightSide p {
    font-size: 18px;
    font-weight: 500;
    padding-right: 24px;
  }
  #userMainDEC {
    display: flex;
    height: 6rem;
    background: white;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16), 0 2px 2px rgba(0, 0, 0, 0.23);
    display: flex;
    width: 100%;
    padding-left: 10px;
    padding-right: 5px;
  }
  #userDec {
    display: flex;
    flex-direction: row;
    margin: auto;
    width: 100%;
  }

  #userDec img {
    margin-right: 10px;
  }
  #userDec p {
    margin-left: 10px;
    margin-bottom: 0;
  }
  #userDec p:nth-of-type(1) {
    margin-bottom: 5px;
  }
  #userDesMenu {
    margin-top: 15px;
    background: white;
    /* border-radius: 10px; */
    box-shadow: 0 3px 4px rgba(0, 0, 0, 0.16), 0 3px 4px rgba(0, 0, 0, 0.23);
  }
  .profileicon {
    width: 3rem;
  }
  .head-profile {
    font-size: 1.625rem;
    font-weight: bold;
  }
  .head-name {
    font-size: 1.625rem;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

@media only screen and (max-width: 600px) {
  #leftmenu {
    display: none;
  }
  #rightmenu {
    padding: 25px;
    margin-top: 35px;
  }
  .infoI {
    position: absolute;
    right: 0;
  }
  #submitBtn {
    text-align: center;
  }
}
</style>
